import React from 'react';
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import StoreHeader from '../../components/layout/StoreHeader';

const TermsPage = () => {
  return (
    <>
      <StoreHeader cartCount={0} />

      <Container maxWidth="lg" sx={{ 
        py: { xs: 2, sm: 4 }, 
        px: { xs: 2, sm: 3 },
      }}>
        <Typography 
          variant="h4" 
          component="h1" 
          gutterBottom 
          sx={{ 
            fontSize: { xs: '1.75rem', sm: '2.25rem', md: '2.5rem' },
            fontWeight: 700,
            color: '#206884',
            mb: 4,
            textAlign: { xs: 'center', sm: 'left' }
          }}
        >
          SMS Terms & Conditions
        </Typography>

        <Typography 
          variant="body1" 
          sx={{ 
            mb: 4,
            fontSize: { xs: '1rem', sm: '1.125rem' },
            color: 'text.secondary',
            maxWidth: '800px'
          }}
        >
          These SMS Terms & Conditions govern the use of text messaging services provided by IMObituary. By providing a mobile phone number and consenting to receive text messages, you agree to the terms outlined below.
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
          {/* Section 1: General Information */}
          <Card variant="outlined" sx={{ boxShadow: 2 }}>
            <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 700,
                  color: '#206884',
                  mb: 3,
                  fontSize: { xs: '1.25rem', sm: '1.5rem' }
                }}
              >
                1. GENERAL INFORMATION
              </Typography>
              <Box component="ul" sx={{ pl: 2, m: 0 }}>
                <Typography component="li" sx={{ mb: 1.5, color: 'text.primary' }}>
                  SMS messages may be sent using an automated or manual system, depending on the use case.
                </Typography>
                <Typography component="li" sx={{ mb: 1.5, color: 'text.primary' }}>
                  Message and data rates may apply depending on your mobile carrier.
                </Typography>
                <Typography component="li" sx={{ mb: 1.5, color: 'text.primary' }}>
                  Consent to receive SMS messages is not a condition of purchase unless explicitly stated.
                </Typography>
                <Typography component="li" sx={{ mb: 1.5, color: 'text.primary' }}>
                  You may opt out of receiving messages at any time by replying STOP.
                </Typography>
                <Typography component="li" sx={{ mb: 0, color: 'text.primary' }}>
                  For assistance, reply HELP.
                </Typography>
              </Box>
            </CardContent>
          </Card>

          {/* Section 3: Order Update Text Messages */}
          <Card variant="outlined" sx={{ boxShadow: 2, border: '2px solid', borderColor: '#206884' }}>
            <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 700,
                  color: '#206884',
                  mb: 3,
                  fontSize: { xs: '1.25rem', sm: '1.5rem' }
                }}
              >
                2. ORDER UPDATE TEXT MESSAGES (THE CARD STORE)
              </Typography>
              
              <Box sx={{ mb: 3 }}>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 600,
                    color: '#206884',
                    mb: 2,
                    fontSize: { xs: '1.1rem', sm: '1.25rem' }
                  }}
                >
                  Purpose
                </Typography>
                <Typography sx={{ color: 'text.primary', mb: 3 }}>
                  Customers who purchase products from The Card Store may opt in to receive text message updates regarding their order.
                </Typography>
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 600,
                    color: '#206884',
                    mb: 2,
                    fontSize: { xs: '1.1rem', sm: '1.25rem' }
                  }}
                >
                  Message Details
                </Typography>
                <Box component="ul" sx={{ pl: 2, m: 0 }}>
                  <Typography component="li" sx={{ mb: 1.5, color: 'text.primary' }}>
                    Message type: Transactional (non-promotional)
                  </Typography>
                  <Typography component="li" sx={{ mb: 1.5, color: 'text.primary' }}>
                    Messages may include order confirmation, shipping updates, and delivery notifications
                  </Typography>
                  <Typography component="li" sx={{ mb: 0, color: 'text.primary' }}>
                    Message frequency varies based on order activity
                  </Typography>
                </Box>
              </Box>

              <Box sx={{ mb: 3 }}>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 600,
                    color: '#206884',
                    mb: 2,
                    fontSize: { xs: '1.1rem', sm: '1.25rem' }
                  }}
                >
                  Consent
                </Typography>
                <Typography sx={{ color: 'text.primary', mb: 3 }}>
                  By opting in during checkout or account setup, you consent to receive transactional SMS messages related to your order.
                </Typography>
              </Box>

              <Box>
                <Typography 
                  variant="h6" 
                  sx={{ 
                    fontWeight: 600,
                    color: '#206884',
                    mb: 2,
                    fontSize: { xs: '1.1rem', sm: '1.25rem' }
                  }}
                >
                  Opt-Out
                </Typography>
                <Typography sx={{ color: 'text.primary' }}>
                  You may opt out at any time by replying STOP. Once opted out, you will no longer receive order-related text messages.
                </Typography>
              </Box>
            </CardContent>
          </Card>

          {/* Section 4: Privacy */}
          <Card variant="outlined" sx={{ boxShadow: 2 }}>
            <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 700,
                  color: '#206884',
                  mb: 3,
                  fontSize: { xs: '1.25rem', sm: '1.5rem' }
                }}
              >
                3. PRIVACY
              </Typography>
              <Typography sx={{ color: 'text.primary' }}>
                We respect your privacy. Mobile phone numbers are used only for the purposes described in these Terms & Conditions and are handled in accordance with our Privacy Policy. We do not sell or share mobile phone numbers with third parties for marketing purposes.
              </Typography>
            </CardContent>
          </Card>

          {/* Section 5: Changes to Terms */}
          <Card variant="outlined" sx={{ boxShadow: 2 }}>
            <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 700,
                  color: '#206884',
                  mb: 3,
                  fontSize: { xs: '1.25rem', sm: '1.5rem' }
                }}
              >
                4. CHANGES TO TERMS
              </Typography>
              <Typography sx={{ color: 'text.primary' }}>
                We reserve the right to update or modify these SMS Terms & Conditions at any time. Any changes will be posted to this page and will become effective immediately upon posting.
              </Typography>
            </CardContent>
          </Card>

          {/* Section 6: Contact Information */}
          <Card variant="outlined" sx={{ boxShadow: 2 }}>
            <CardContent sx={{ p: { xs: 3, sm: 4 } }}>
              <Typography 
                variant="h5" 
                sx={{ 
                  fontWeight: 700,
                  color: '#206884',
                  mb: 3,
                  fontSize: { xs: '1.25rem', sm: '1.5rem' }
                }}
              >
                5. CONTACT INFORMATION
              </Typography>
              <Typography sx={{ color: 'text.primary', mb: 2 }}>
                If you have questions about these SMS Terms & Conditions, please contact us at:
              </Typography>
              <Typography 
                component="a" 
                href="mailto:admin@imobituary.com"
                sx={{ 
                  color: '#206884',
                  fontWeight: 600,
                  textDecoration: 'none',
                  '&:hover': {
                    textDecoration: 'underline',
                    color: '#6CCC16'
                  }
                }}
              >
                admin@imobituary.com
              </Typography>
            </CardContent>
          </Card>
        </Box>
      </Container>
    </>
  );
};

export default TermsPage;
